import React, {useEffect, useState} from "react"
import PropTypes from "prop-types"

const Widget = ({title = null, description = null, right = null, children, collapsible = false, defaultOpen = true}) => {

  const [open, setOpen] = useState(defaultOpen)

  const toggle = () => {
    if (collapsible) setOpen(!open)
  }

  useEffect(() => {
    setOpen(defaultOpen)
  }, [defaultOpen])

  return (
      <div className={`widget w-full p-4 mb-4 rounded-lg bg-white border border-grey-100 dark:bg-grey-895 dark:border-grey-890`}>

        {(title || description || right) && (
            <div className={`flex flex-row items-center justify-between ${collapsible ? "cursor-pointer" : ""}`}
                onClick={toggle}
            >
              <div className="flex flex-col">
                <div className={"flex flex-row"}>
                  {collapsible && (
                      <div className="text-black pr-2">
                        {open ? "▲" : "▼"}
                      </div>
                  )}
                  <div className="text-sm font-light text-black">{title}</div>
                </div>
                <div className="text-sm font-bold">{description}</div>
              </div>
              <div className="flex items-center gap-2">
                {right}
              </div>
            </div>
        )}

        {(!collapsible || open) && children}

      </div>
  )
}

Widget.propTypes = {
  title: PropTypes.any,
  description: PropTypes.any,
  right: PropTypes.any,
  children: PropTypes.any,
  collapsible: PropTypes.bool,
  defaultOpen: PropTypes.bool
}

export default Widget
